
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgProgressModule } from 'ngx-progressbar';
import { SharedModule } from '../shared/shared.module';
import { ManageRenewalsPortalRoutingModule } from './manage-renewals-portal-routing.module';
import { ManageRenewalsPortal } from './manage-renewals-portal.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { ManageRenewalsDetails } from './manage-renewals-details/manage-renewals-details.component';
import { RenewalsCheckoutComponent } from './renewlas-checkout/renewals-checkout.component';
import { ManageLtedetailsComponent } from './manage-upcoming-opportunity/manage-ltedetails/manage-ltedetails.component';
import { ManageRenewlasSearchComponent } from './manage-upcoming-opportunity/manage-renewlas-search/manage-renewlas-search.component';
import { ManageRenewalsAnnuitiesComponent } from './manage-upcoming-opportunity/manage-renewals-annuities/manage-renewals-annuities.component';
import { ManageUpcomingOpportunityComponent } from './manage-upcoming-opportunity/manage-upcoming-opportunity.component';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { ManageMonthComponent } from './manage-month/manage-month.component';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule  } from '@angular/material/slide-toggle';
import { ModalPopupModule } from '../shared/modal-popup/modal-popup.module';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    imports: [
        CommonModule,
        NgProgressModule,
        NgxPaginationModule,
        SharedModule,
        NgbModule,
        FormsModule,
        MatSortModule,
        MatOptionModule,
        MatSlideToggleModule,
        NgSelectModule,
        MatTabsModule,
        MatInputModule,
        MatDialogModule,
        NgSelectModule,
        ManageRenewalsPortalRoutingModule,
        ChildHeaderModule,
        ModalPopupModule,
        BreadcrumbModule,
        MatTooltipModule
    ],
    declarations: [
        ManageRenewalsPortal,
        ManageMonthComponent,
        ManageRenewalsDetails,
        RenewalsCheckoutComponent,
        ManageLtedetailsComponent,
        ManageRenewlasSearchComponent,
        ManageRenewalsAnnuitiesComponent,
        ManageUpcomingOpportunityComponent
    ]
})
export class ManageRenewalsPortalModule { }
